import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  async getTranslatedCalibrationHomepageMessage({ commit, dispatch }, languageCode) {
    const r = await startLoading(dispatch, 'getTranslatedCalibrationHomepageMessage', () =>
      http.get(`NotificationMessage/GetTranslatedCalibrationWelcomeMessage?languageCode=${languageCode}`)
    )
    commit(types.SET_TRANSLATED_CALIBRATION_WELCOME_MESSAGE, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/notificationmessage/actions.js